// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Support_wrapper__v813B","button":"Support_button__13Gbr","icon":"Support_icon__dRD3G"};